/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { useSelector } from 'react-redux';
import mbpLogger from 'mbp-logger';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useSalesforcePersonalizedContentQuery from '../useSalesforcePersonalizedContentQuery';

export const useAuthCallBackTest = (brand) => {
    const ffIsAuthCallbackEnabled = useSelector(getFeatureFlag('is-auth-callback-enabled'));
    let isAuthCallbackEnabled = false;
    const brandName = brand?.domain || '1800flowers';
    const interactionName = `${brandName} - Get Campaign - Personalized Landing Page`;
    const targeting = {
        pageType: 'home',
    };
    const {
        loading, error, data, variables,
    } = useSalesforcePersonalizedContentQuery({
        queryName: 'AuthCallbackTest',
        interactionName,
        targeting,
        optInHoldoutParticipation: true,
        resolveIdentity: false,
        featureFlag: ffIsAuthCallbackEnabled,
    });

    if (loading || variables?.skip) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'AuthCallbackTest.js',
            message: 'Error loading data from PersonalizedContent API',
            appName: process.env.npm_package_name,
            module: 'Auth callback test',
            jsError: error,
        });
    }

    if (data?.contentSF) {
        const userGroup = data?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
        isAuthCallbackEnabled = userGroup?.toLowerCase?.() === 'test';
        if (typeof window !== 'undefined' && window.sessionStorage) {
            window.sessionStorage.setItem('authCallBackSFData', data?.contentSF ? JSON.stringify(data?.contentSF) : '{}');
            window.sessionStorage.setItem('isAuthCallbackEnabled', isAuthCallbackEnabled);
        }
    }

    return isAuthCallbackEnabled;
};

export default useAuthCallBackTest;
